import { DEFAULT_PASSWORD_HINTS, MAX_HINTS, PASSWORD_HINT_KEYS, PASSWORD_HINT_MAP } from './constants';

var getAriaDescribedBy = _ref => {
  var {
    displayError,
    hints
  } = _ref;
  var errorElId = displayError ? 'password-error' : '';
  var hintsElId = hints ? 'password-hints' : '';
  var attrValue = "".concat(errorElId, " ").concat(hintsElId).trim();
  return attrValue.length ? attrValue : undefined;
};

var getPasswordHints = validation => {
  var hints = PASSWORD_HINT_KEYS.reduce((accum, key) => {
    var isValid = !validation[key];

    if (isValid && !DEFAULT_PASSWORD_HINTS.includes(key)) {
      return accum;
    }

    var {
      name,
      type
    } = PASSWORD_HINT_MAP[key];
    accum.push({
      isValid,
      name,
      type
    });
    return accum;
  }, []);
  return hints.length > MAX_HINTS ? hints.filter(_ref2 => {
    var {
      isValid
    } = _ref2;
    return !isValid;
  }).slice(0, MAX_HINTS) : hints;
};

var hasUserChanged = (newUser, oldUser) => {
  if (!newUser || !oldUser) {
    return false;
  }

  return ['dob', 'firstName', 'lastName'].some(key => newUser[key] !== oldUser[key]);
};

export { getAriaDescribedBy, getPasswordHints, hasUserChanged };